import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';

/**
 *
 * @param type
 * @param action
 * @param label
 * @param timeout
 * @returns {*}
 */
function trackEvent(type='lead', action='click', label='', timeout=1000) {
	const promises = [];

	// Google Analytics
	if (typeof ga === 'function') {

		promises.push(new Promise((resolve, reject) => {

			ga('send', {
				hitType: 'event',
				eventCategory: type,
				eventAction: action,
				eventLabel: label,
				hitCallback: () => resolve(),
			});

			setTimeout(() => reject(), timeout);
		}));
	}

	// Facebook Pixel
	if (typeof fqb === 'function') {

		promises.push(new Promise((resolve, reject) => {

			fbq('track', 'Lead');
			resolve();

			// Facebook Pixel has no callback...
			// setTimeout(() => reject(), timeout);
		}));
	}

	return Promise.all(promises);
}

/**
 *
 * @param context
 */
export default function trackerDirective(context=document.body) {
	const $context = $(context);

	$context.find('[sw-tracker]').each(function() {
		const $element = $(this);
		const json = $element.attr('sw-tracker');
		const settings = directiveSettings(json, {
			on: 'auto',
			type: 'lead',
			label: '',
			timeout: 1000,
		}, 'label');

		if (settings.on === 'auto') {
			if ($element.is('form')) {
				settings.on = 'submit';
			} else {
				settings.on = 'click';
			}
		}

		$element.on(`${settings.on}.tracker`, (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();

			const trigger = () => {
				$element.off('.tracker');
				$element.trigger(settings.on);

				if (settings.on === 'click' && $element.is('a[href]')) {
					this.click();
				}
			};

			trackEvent(settings.type, settings.on, settings.label, settings.timeout)
				.then(trigger)
				.catch(trigger);
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/tracker.js